import { MutationTree } from 'vuex';
import { DialogState } from './types';

export const mutations: MutationTree<DialogState> = {
  dialogClose(state) {
    state.show = false;
    state.cancel = false;
    state.message = '';
    state.callbackFn = () => {};
    state.cancelCallbackFn = () => {};
  },
  dialogTypeConfirm(state, payload: DialogState) {
    state.cancel = true;
    state.show = true;
    state.message = payload.message;
    state.callbackFn = payload.callbackFn;
    state.cancelCallbackFn = payload.cancelCallbackFn;
  },
  dialogTypeAlert(state, payload: DialogState) {
    state.show = true;
    state.cancel = false;
    state.message = payload.message;
    state.callbackFn = payload.callbackFn;
  }
};
